import React from "react";

export default function ExperienceDetailsSkeleton() {
  return (
    <div className="container mx-auto py-10 px-6 animate-pulse">
      {/* Page Header */}
      <div className="h-8 w-56 bg-gray-200 rounded mb-8"></div>

      {/* Hero Section */}
      <div className="w-full h-[380px] bg-gray-200 rounded-xl mb-10"></div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        {/* LEFT SIDE */}
        <div className="col-span-2 space-y-6">
          {/* Title */}
          <div className="h-7 w-2/3 bg-gray-200 rounded"></div>

          {/* Location */}
          <div className="h-4 w-1/3 bg-gray-200 rounded"></div>

          {/* Price */}
          <div className="h-6 w-32 bg-gray-200 rounded"></div>

          {/* Description */}
          <div className="space-y-3 mt-4">
            <div className="h-4 w-full bg-gray-200 rounded"></div>
            <div className="h-4 w-full bg-gray-200 rounded"></div>
            <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
          </div>

          {/* Vendor Info */}
          <div className="mt-8 p-6 border rounded-xl flex gap-4">
            <div className="h-20 w-20 bg-gray-200 rounded-full"></div>
            <div className="flex-1 space-y-3">
              <div className="h-5 w-1/3 bg-gray-200 rounded"></div>
              <div className="h-4 w-full bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE (Availability) */}
        <div className="border rounded-xl p-6 space-y-6">
          <div className="h-6 w-1/2 bg-gray-200 rounded"></div>

          {/* Calendar */}
          <div className="grid grid-cols-7 gap-2">
            {[...Array(14)].map((_, i) => (
              <div key={i} className="h-10 w-full bg-gray-200 rounded"></div>
            ))}
          </div>

          {/* Time Slots */}
          <div className="space-y-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-10 w-full bg-gray-200 rounded"></div>
            ))}
          </div>

          {/* Book Button */}
          <div className="h-12 w-full bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  );
}
